import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApFormControlPipe } from '@ap/cdk';
import { ApContentModule } from '@ap/content';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApColComponent, ApRowComponent, ApSmDirective } from '@ap/grid';
import { ApInputComponent } from '@ap/input';

import { DeviceComponent } from './device.component';

/**
 * @ngdoc module
 * @name DeviceModule
 **/
@NgModule({
    imports: [
        ApButtonComponent,
        ApContentModule,
        ApFormErrorsComponent,
        ApRowComponent,
        ApColComponent,
        ApSmDirective,
        ApFormControlPipe,
        ApInputComponent,
        ReactiveFormsModule
    ],
    declarations: [DeviceComponent],
    exports: [DeviceComponent]
})
export class DeviceModule {}
